<template>
  <ContentBanner
    variant="error"
    icon="cross-outline"
    title="Nothing on File"
    primary-label="Create"
  >
    <p class="text-body-3 text-textLight mb-0">
      This employee has no completed acknowledgements on file.
    </p>
    <template #actions>
      <DpplDarkTooltip
        v-if="!isActionEnabled"
        tooltip-placement="bottom"
        light-mode
      >
        <template #activator="{ onMouseenter, onMouseleave }">
          <span
            class="banner-action-disabled-wrapper"
            @mouseenter="onMouseenter"
            @mouseleave="onMouseleave"
          >
            <v-btn
              color="brandPrimary"
              variant="flat"
              size="small"
              disabled
            >
              Create
            </v-btn>
          </span>
        </template>
        <template #tooltip-content>
          <p class="text-body-2 text-textDark">
            {{ disabledTooltip }}
          </p>
        </template>
      </DpplDarkTooltip>
      <v-btn
        v-else
        color="brandPrimary"
        variant="flat"
        size="small"
        @click="emit('create')"
      >
        Create
      </v-btn>
    </template>
  </ContentBanner>
</template>

<script setup>
import ContentBanner from '@/components/library/ContentBanner.vue';
import DpplDarkTooltip from '@/components/datapeople/DpplDarkTooltip.vue';

defineProps({
  isActionEnabled: { type: Boolean, default: true },
  disabledTooltip: { type: String, default: '' },
});

const emit = defineEmits(['create']);
</script>

<style scoped lang="less">
.banner-action-disabled-wrapper {
  display: inline-block;
}
</style>
